import { TorchApplicationData, TorchApplicationTypes } from '../../components/TorchApplicationContext'

interface BuildSrcUrlProps {
  data: TorchApplicationData | null | undefined
  id?: string
  type: TorchApplicationTypes
}

const TORCH_FORM_URL = 'https://form.jotform.com/242745606833158'
const FULL_FILM_FORM_URL = 'https://form.jotform.com/250293997876074'

export const buildSrcUrl = ({ data, id, type }: BuildSrcUrlProps) => {
  if (!data || !id) return null

  const url = new URL(type === TorchApplicationTypes.FullFilm ? FULL_FILM_FORM_URL : TORCH_FORM_URL)
  const [firstName = ''] = data.filmmakerName?.split(' ') || []

  const params = {
    isIframeEmbed: '1',
    'name15[first]': firstName,
    'name15[last]': data.filmmakerName?.replace(`${firstName} `, ''),
    email: data.filmmakerEmail,
    'companyAddress[addr_line1]': data.addressLine1,
    'companyAddress[addr_line2]': data.addressLine2,
    'companyAddress[city]': data.city,
    'companyAddress[state]': data.state,
    'companyAddress[postal]': data.zipCode,
    'companyAddress[country]': data.country,
    companyTitle: data.filmmakerRole,
    whatIs: data.title,
    whatType: data.productionType,
    applicationId: id,
    nameOf: data.companyName,
  }

  Object.entries(params).forEach(([key, value]) => url.searchParams.append(key, value || ''))

  return url.toString()
}

export const isOriginPermitted = (originUrl: string, whitelistedDomains: string[]) => {
  const url = document.createElement('a')
  url.href = originUrl
  const hostname = url.hostname
  let result = false
  if (typeof hostname !== 'undefined') {
    whitelistedDomains.forEach(function (element) {
      if (hostname.slice(-1 * element.length - 1) === '.'.concat(element) || hostname === element) {
        result = true
      }
    })
    return result
  }
}
